import React from "react";


export default function Quiz ({ quiz, completeQuiz, completedQuiz, frontpageObject, handleChangeAnswers, checkedAnswers, scores, quizLen}){
    let id = `answer_${quiz.id}`

    let activetTab = completedQuiz[id] !== undefined ? completedQuiz[id].activeTab : 0
    return (
        <form action="" className="form form-ajax">
          <div className="form__title form__title_center"
            dangerouslySetInnerHTML={{__html: quiz.title.rendered}}
          />

          <div className="questions">
              {
                quiz.acf.questions.map(({question}, k) => (
                  <React.Fragment key={k}>
                    <div className={`question ${k == activetTab ? 'active' : ''}`} key={k}>

                      <div className="question__number">{k + 1}</div>

                      <div className="form__label form__label_marg form__label_center form__label_tooltip">
                        <span className="tooltip">
                          <span className="tooltip__icon">?</span>

                          <div className="tooltip__info"
                            dangerouslySetInnerHTML={{__html: question.hint}}
                          />

                        </span>
                        <div
                          dangerouslySetInnerHTML={{__html: question.question}}
                        />
                      </div>

                      <div className="radio-wrap">
                        {question.answer.map((answer, i) => (
                          <div key={i} className="radio">
                            <label htmlFor={`${id}_${k}`} className="radio__label radio__label_js">

                              <input
                                checked={
                                  checkedAnswers[`${id}_${k}`] !== undefined && answer.options == checkedAnswers[`${id}_${k}`]
                                    ? 'checked'
                                    : false}
                                  onChange={(e) => {
                                    let checked = checkedAnswers[`${id}_${k}`]
                                    setTimeout(() => {
                                      quiz.acf.questions.length - 1 !== k && checked === undefined && completeQuiz(e, id, false, k+1, false)
                                    }, 250)

                                    handleChangeAnswers(k, id, parseInt(answer.score), `${id}_${k}`, answer.options)
                                  }}
                                  value={answer.options}
                                  type="radio"
                                  name={`${id}_${k}`}
                              />
                              <span className="radio__text"
                                dangerouslySetInnerHTML={{__html: answer.options}}
                              />
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </React.Fragment>
                ))
              }
            <div className="questions-dots row">
              {
                quiz.acf.questions.map((q, k) => (
                  <div key={k} className={`questions-dots__dot ${activetTab == k && 'active'}`} onClick={(e) => completeQuiz(e, id, false, k)} />
                ))
              }
            </div>

              {
                scores[id] != undefined && Object.keys(quiz.acf.questions).length == Object.keys(scores[id]).length
                ? <div className="form__btns row">

                  {quizLen + 1 !== Object.keys(completedQuiz).length
                    &&
                    <button onClick={(e) => completeQuiz(e, id, true, false)} type="button" className="form-submit-btn">
                      <span
                        dangerouslySetInnerHTML={{__html: frontpageObject.acf.quiz_buttons.check_other_category}}
                      />
                    </button>
                  }
                    <button onClick={(e) => completeQuiz(e, id, true, false, true)} type="button" className="form-submit-btn">
                        <span
                            dangerouslySetInnerHTML={{__html: frontpageObject.acf.quiz_buttons.last_screen}}
                        />
					</button>
                  </div>
                : ''
              }
          </div>

        </form>
    )

}
